module.exports = __webpack_public_path__ + "img/Read.0f51158c.svg";